import { WithSharedResourceDownload } from 'components/common/withSharedResourceDownload/withSharedResourceDownload';
import { Layout, Toaster } from 'components/core';
import { DownloadWithToken } from 'components/report/download/downloadWithToken';
import React from 'react';
import {
  FullScreenSpinner,
  useResolvedIsAuthenticated,
} from 'views/reports/authResolution';

function ReportDownloadView(): React.ReactElement {
  const isAuthenticated = useResolvedIsAuthenticated();

  if (isAuthenticated === undefined) {
    return (
      <FullScreenSpinner reason='ReportDownloadView awaiting auth resolution' />
    );
  }

  return (
    <WithSharedResourceDownload entityType='report'>
      {isAuthenticated ? (
        <Layout>
          <DownloadWithToken />
        </Layout>
      ) : (
        <>
          <DownloadWithToken />
          <Toaster />
        </>
      )}
    </WithSharedResourceDownload>
  );
}

export default ReportDownloadView;
